import { render } from "./zonghe-ticheng.vue?vue&type=template&id=98e412c8&scoped=true"
import script from "./zonghe-ticheng.vue?vue&type=script&lang=js"
export * from "./zonghe-ticheng.vue?vue&type=script&lang=js"

import "./zonghe-ticheng.vue?vue&type=style&index=0&id=98e412c8&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e412c8"]])

export default __exports__